import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { HeaderRoutingModule } from './header-routing.module';
import { HeaderComponent } from './header.component';
import { DialogRegistrationsClosedComponent } from './dialog-registrations-closed/dialog-registrations-closed.component';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import {MatMenuModule} from '@angular/material/menu';

@NgModule({
  declarations: [
    HeaderComponent,
    DialogRegistrationsClosedComponent
  ],
  imports: [
    CommonModule,
    HeaderRoutingModule,
    MatIconModule,
    MatButtonModule,
    MatDialogModule,
    MatMenuModule
  ],
  exports : [HeaderComponent]
})
export class HeaderModule { }
